if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Begin custom payload
        const payload = {
          items: [],
          sections: formData.get('sections'),
          sections_url: formData.get('sections_url'),
        };

        const productTypes = {
          box: 'box',
          customization: 'customization',
          product: 'product',
          box_product: 'box_product',
        };

        // Retrieve customization data
        const customizationId = Date.now() + '-customization';
        const freeCustomizationId = Date.now() + '-free-customization';

        const customizationContainer = document.querySelector('up-broderie');
        const customizationEnabled = customizationContainer ? customizationContainer.querySelector('#up-broderie-toggle').checked : false;
        const freeCustomization = customizationEnabled && customizationContainer.hasAttribute('data-free-customization');

        const customizationText = customizationEnabled ? customizationContainer?.getAttribute('data-currenttext') : false;
        const customizationBackground = customizationEnabled ? customizationContainer?.getAttribute('data-background') : false;

        const customizationColor = customizationEnabled ? customizationContainer?.getAttribute('data-currentcolor') : false;
        const customizationColorName = customizationEnabled ? customizationContainer?.getAttribute('data-currentcolorname') : false;
        const customizationFont = customizationEnabled ? customizationContainer?.getAttribute('data-currentfont') : false;
        const customizationFontName = customizationEnabled ? customizationContainer?.getAttribute('data-currentfontname') : false;

        // Add products as part of a coffret
        const boxProductsSelectElement = document.querySelector('#up-coffret-selects-products');
        const selectedBoxProducts = boxProductsSelectElement ? Array.from(boxProductsSelectElement.querySelectorAll('input')).filter(checkbox => !checkbox.disabled && checkbox.checked).map(input => ({
          id: input.value,
          customizable: input.hasAttribute('data-customizable'),
          free_customization: input.hasAttribute('data-free-customization'),
        })) : [];

        // Return error if number of products is less than specified limit
        const minNumberOfProducts = parseInt(window.box_min_products);

        if (boxProductsSelectElement && selectedBoxProducts.length < minNumberOfProducts) {
          const error = window.box_min_products_error;

          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: error,
            message: error,
          });

          this.handleErrorMessage(error);
          this.error = true;

          this.querySelector('.loading__spinner').classList.add('hidden');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');

          return;
        }

        // Add main product
        const mainProduct = {
          id: formData.get('id'),
          quantity: 1,
          properties: {},
        };

        if (selectedBoxProducts.length) {
          // Set product type to box
          mainProduct.properties._product_type = productTypes.box;

          // Add box products
          selectedBoxProducts.forEach(selectedBoxProduct => {
            const boxProduct = {
              id: selectedBoxProduct.id,
              quantity: 1,
              properties: {
                _product_type: productTypes.box_product,
                _box_id: formData.get('id'),
              },
            };

            if (selectedBoxProduct.customizable) {
              if (selectedBoxProduct.free_customization) {
                boxProduct.properties._customization_id = freeCustomizationId;
                boxProduct.properties._free_customization = true;
              } else {
                boxProduct.properties._customization_id = customizationId;
              }
            }

            payload.items.push(boxProduct);
          });
        } else {
          // Set product type to product
          mainProduct.properties._product_type = productTypes.product;

          // Add customization id
          if (customizationEnabled) {
            if (freeCustomization) {
              mainProduct.properties._free_customization = true;
              mainProduct.properties._customization_id = freeCustomizationId;
            } else {
              mainProduct.properties._customization_id = customizationId;
            }
          }
        }

        payload.items.push(mainProduct);

        // Add customization
        if (customizationEnabled && customizationText) {
          const customizationProductProperties = {
            properties: {
              _product_type: productTypes.customization,

              _customization_text: customizationText,
              _customization_font: customizationFont,
              _customization_color: customizationColor,
              _customization_background: customizationBackground,

              Texte: customizationText,
              Police: customizationFontName,
              Couleur: customizationColorName,
            }
          };

          if (selectedBoxProducts.length) {
            const customizationProduct = {
              ...customizationProductProperties,
              id: customization_product.variants[0].id,
              quantity: selectedBoxProducts.length ? selectedBoxProducts.filter(selectedBoxProduct => selectedBoxProduct.customizable && !selectedBoxProduct.free_customization).length : 0,
              properties: {
                ...customizationProductProperties.properties,
                _customization_id: customizationId,
              }
            };

            const freeCustomizationProduct = {
              ...customizationProductProperties,
              id: free_customization_product.variants[0].id,
              quantity: selectedBoxProducts.length ? selectedBoxProducts.filter(selectedBoxProduct => selectedBoxProduct.customizable && selectedBoxProduct.free_customization).length : 0,
              properties: {
                ...customizationProductProperties.properties,
                _customization_id: freeCustomizationId,
              }
            };

            customizationProduct.properties._box_id = formData.get('id');
            freeCustomizationProduct.properties._box_id = formData.get('id');

            payload.items.push(customizationProduct);
            payload.items.push(freeCustomizationProduct);
          } else {
            const customizationProduct = {
              ...customizationProductProperties,
              id: freeCustomization ? free_customization_product.variants[0].id : customization_product.variants[0].id,
              properties: {
                ...customizationProductProperties.properties,
                _customization_id: freeCustomization ? freeCustomizationId : customizationId,
              },
              quantity: 1,
            };

            payload.items.push(customizationProduct);
          }
        }
        // End custom payload

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
